{
  "openapi": "3.0.0",
  "info": {
    "title": "Husbanken-application-template API",
    "version": "ergrg",
    "description": "API ment for frontend SPA"
  },
  "tags": [
    {
      "name": "eksempel",
      "description": "Eksempel-API"
    }
  ],
  "servers": [
    {
      "url": "http://localhost:4200/api"
    }
  ],
  "paths": {},
  "components": {
    "schemas": {
      "Skjemaliste": {
        "properties": {
          "sikkerInnsendingSkjemaV1": {
            "$ref": "#/components/schemas/SikkerInnsendingDataTO"
          }
        }
      },
      "SikkerInnsendingDataTO": {
        "properties": {
          "tittel": {
            "type": "string"
          },
          "melding": {
            "type": "string"
          },
          "epost": {
            "type": "string"
          },
          "telefonnummer": {
            "type": "string"
          },
          "spraak": {
            "type": "string"
          },
          "vedlegg": {
            "type": "array",
            "items": {
              "type": "string"
            }
          }
        }
      }
    }
  }
}

